import DIALOG from '../../../../DOM/dialog/DIALOG.js';
import { text } from '../../../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import BUTTONGROUP, { buttongroup } from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { button } from '../../../../DOM/button/BUTTON.js';
import { span } from '../../../../DOM/span/SPAN.js';
import { SVGS } from '../../../../SVG/SVGS.js';
import { icon } from '../../../../SVG/icon/ICON.js';
import { navheader } from '../../../../DOM/nav/navbar/navheader/NAVHEADER.js';
// Model Structure
export const appSettingsDialogAttr = makeAttrStruct([
    ['open'],
    ['closeOnFocusOut', true]
]);
export const appSettingsDialogData = makeDataStruct([
    ['caller', null],
    ['loader'],
    ['header', navheader('AppSettings')],
    ['footer', {}],
    ['text', text('App Settings')],
    ['onConfirm', () => { }],
    ['onCancel', () => { }]
]);
export const appSettingsDialogModel = makeStruct([
    ['attributes', appSettingsDialogAttr],
    ['data', appSettingsDialogData]
]);
// Simplified Model
export function appSettingsDialog(caller, loader, text, header, footer) {
    return {
        attributes: appSettingsDialogAttr(),
        data: appSettingsDialogData(caller, loader, header, footer, text)
    };
}
/** A DIALOG with an embedded FORM that can be used to recieve input
    @description Creates a dialog and displays a text well and any included buttons
*/
export default class APPSETTINGS extends DIALOG {
    constructor(node, model) {
        super(node, model);
        this.addClass('appsettings');
        this.caller.on('deactivate', () => this.closeDialog());
        let buttonGroup = new BUTTONGROUP(this.content, buttongroup('app-settings-buttons', 'vertical has-background'));
        buttonGroup.addButton(button(span('Theme Settings', 'btn-theme'), 'btn-theme', icon(SVGS.GEAR), 'Configure application theme'))
            .on('click', () => {
            console.log('Theme Settings clicked');
        });
        buttonGroup.addButton(button(span('Language Settings', 'btn-language'), 'btn-language', icon(SVGS.GEAR), 'Configure language settings'))
            .on('click', () => {
            console.log('Language Settings clicked');
        });
        buttonGroup.addButton(button(span('Display Settings', 'btn-display'), 'btn-display', icon(SVGS.GEAR), 'Configure display settings'))
            .on('click', () => {
            console.log('Display Settings clicked');
        });
    }
}
